// extracted by mini-css-extract-plugin
module.exports = {"h":"LabelH_h__RXOew"};